import { Link } from 'react-router-dom'

export function Brand({ inverse = false }: { inverse?: boolean }) {
  return (
    <Link
      className={`brand ${inverse ? 'brand--inverse' : ''}`}
      to="/"
      aria-label="GK Maison, página inicial"
    >
      <img
        src="/logo-gk-maison.png"
        alt="GK Maison"
        className="brand__logo-image"
      />
    </Link>
  )
}